module.exports = __webpack_public_path__ + "img/tn.5c013018.svg";